import { graphql } from "@/lib/gql/__generated__";

export const GoogleFreeBookingLinksSettings = graphql(`
	query GoogleFreeBookingLinksSettings($hotelID: ID!) {
		hpbSettings(hotelID: $hotelID) {
			id
			hotelID
		}
		googleFreeBookingLinksSettings(hotelID: $hotelID) {
			id
			hotelID
			status
			notConnectedReason
			hotelType
			hotelName
			address {
				country
				addr1
				addr2
				addr3
				city
				province
				postalCode
			}
			geoLocation {
				lat
				lon
			}
			webSite
			chillnnGuestPageType
			phoneNumbers {
				phoneType
				phoneNumber
			}
			defaultPlanID
			defaultRoomID
			capacity
			createdAt
			updatedAt
		}
		planList(hotelID: $hotelID) {
			id
			hotelID
			plans {
				planID
				name
				id
				inSale
				isDayTrip
			}
			secrets {
				planID
				name
				id
				inSale
				isDayTrip
			}
		}
		roomList(hotelID: $hotelID) {
			id
			rooms {
				id
				name
				roomID
				inSale
			}
			dummy {
				id
				roomID
				name
				inSale
			}
		}
	}
`);
